import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTitle: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Default title
    let title = 'Staruprahi - Startup News & Business Insights';

    // Dynamic titles based on route
    if (location.pathname === '/') {
      title = 'Staruprahi - Latest Startup News & Business Insights';
    } else if (location.pathname === '/about') {
      title = 'About Us - Staruprahi';
    } else if (location.pathname === '/subscribe') {
      title = 'Subscribe - Staruprahi';
    } else if (location.pathname.startsWith('/category/')) {
      const category = location.pathname.split('/category/')[1];
      const formattedCategory = category.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      title = `${formattedCategory} - Staruprahi`;
    } else if (location.pathname.startsWith('/news/')) {
      title = 'Article - Staruprahi';
    }

    // Update document title
    document.title = title;
  }, [location]);

  return null;
};

export default PageTitle;